<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-07-29 15:01:30
 * @FilePath: \gcp-fe\src\app\shop\components\detail-table.vue
 * @Description: 表格组件
-->
<template>
  <div>
    <template>
      <el-table
        :data="tableData"
        :fit="true"
        @selection-change="selectionChange"
        border
        class="multifunctional-table dic-sub-table-style01"
        :empty-text="$t('page.content.noData')"
      >
        <el-table-column
          type="selection"
          :width="commonTableWidth.checkboxWidth"
          v-if="showCheckBox"
          align="center"
          header-align="center"
        />
        <el-table-column
          type="index"
          :width="$TW.serialNoWidth"
          :label="$t('page.content.serialNo')"
          align="center"
          v-if="showIndex"
        >
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableHead">
          <el-table-column
            :key="index"
            :label="table.label"
            :width="table.width"
            :min-width="table.width"
            :prop="table.prop"
            :align="table.align"
            :header-align="table.headerAlign"
            :show-overflow-tooltip="true"
            :formatter="table.formatter"
            v-if="!table.isHidden"
          >
            <template slot-scope="scope">
              <el-button
                v-if="table.slot === 'opp'"
                type="text"
                @click="download(scope.$index, scope.row)"
                >{{ $t("page.content.downLoad") }}</el-button
              >
              <el-button
                v-if="table.slot === 'opp'"
                type="text"
                @click="preview(scope.row)"
              >
                <!--预览-->
                {{ $t("page.content.preview") }}
              </el-button>

              <template v-else-if="table.slot === 'fileSize'">
                <span> {{ scope.row.fileSize }}kb</span>
              </template>
              <template v-else-if="table.slot === 'quantities'">
                <span> {{ scope.row.quantities }}{{ scope.row.unitName }}</span>
              </template>

              <slot
                v-else-if="table.slot"
                :row="scope.row"
                :$index="scope.$index"
                :name="table.slot"
              ></slot>
              <template v-else>
                <span
                  v-if="scope.row.required && scope.row.prop === table.prop"
                  style="color: #ff0000"
                  >*</span
                >
                {{ scope.row[table.prop] || "" }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
    <downloadVerificationCode
      :dialogVisible="dialogVisible"
      :dialogSureCallback="dialogSureCallback"
      @opSure="downloading"
      @cancel="cancelDialogVisible"
    >
    </downloadVerificationCode>
  </div>
</template>

<script>
import { addUrlPerFix, getPreviewUrl } from "@/basa/utils";
import { commonTableWidth } from "@/setting/setting";
import downloadVerificationCode from "@/app/shop/components/download-verification-code";

import Cookies from "js-cookie";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "detail-table",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    typeTable: {
      type: String,
      default: ""
    }
  },
  components: {
    downloadVerificationCode
  },
  data() {
    return {
      commonTableWidth: commonTableWidth,
      dialogVisible: false,
      dialogSureCallback: null
    };
  },
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },
    download(index, row) {
      console.log(this.typeTable, "this.typeTable");
      if (!Cookies.get("access_token")) {
        this.dialogVisible = true;
        this.dialogSureCallback = row;
      } else {
        if (this.typeTable === "FB") {
          this.downloadFB(row);
        } else {
          this.downloading(row);
        }
      }
    },
    cancelDialogVisible() {
      this.dialogVisible = false;
    },
    downloading(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_SP_URL
      )}/apis/sp/oss/users/signup/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;

      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
      this.cancelDialogVisible();
    },
    //预览
    preview({ uploadId }) {
      if (!Cookies.get("access_token")) {
        this.$message({
          message: "预览，请先登录！",
          type: "warning",
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        getPreviewUrl(uploadId);
      }
      // preview({ fileUrl }) {
      //   getPreviewUrl(fileUrl);
      // const previewSrc = getPreviewUrl(fileUrl);
      // window.open(previewSrc);
    },
    downloadFB(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_SCP_URL
      )}/apis/scp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    }
  }
};
</script>

<style scoped></style>
